import { Component, OnInit } from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {ActivatedRoute, Router} from '@angular/router';
import { UserService } from '../../../../core/user.service';
import { CqmnsProjectPopupComponent } from "../../../../_models/cqmns-project-popup/cqmns-project-popup.component";
import {MatDialog, MatDialogConfig} from "@angular/material";
import { AuthService } from '../../../../core/auth/auth.service';

@Component({
  selector: 'app-cqmns-approved-rca',
  templateUrl: './cqmns-approved-rca.component.html',
  styleUrls: ['./cqmns-approved-rca.component.css']
})
export class CqmnsApprovedRcaComponent implements OnInit {

  hostUrl = this.userService.getUrl();
  projectId: any;
  issues: any;
  approvedIssues: any;
  value = 'select';
  p:any;
  message: any;
  source: any=[];
  project:any;
  projectName:any;
  userId: any;
    constructor(private http: HttpClient, 
      private route: ActivatedRoute, 
      private router: Router, 
      private userService: UserService,
      private matDialog: MatDialog, private authService: AuthService, 
      ) { }
    oldField = "";
    order = true;
    sortapprovedAssign = "fa fa-sort";
    sortreview_date = "fa fa-sort";
    sortDescription = "fa fa-sort";
    sortRootCause = "fa fa-sort";
    sortautoClassification = "fa fa-sort";
    isDesc = false;
  ngOnInit() {
    this.authService.user() .subscribe(
      data => {});
      this.userId = localStorage.getItem("userid");

  //  this.projectId = this.route.snapshot.params['projectId'];
  this.projectId = localStorage.getItem("projectId");
  this.projectName = localStorage.getItem("cqm-project-name");
        this.http.get(encodeURI(this.hostUrl+'/api/issue/rcabystatus/' + this.projectId)).subscribe(
          data => {
              this.approvedIssues = data;
            }
        );
        this.http.get(encodeURI(this.hostUrl+'/api/issue/sourceClassification/' + this.projectId))
        .subscribe( data => {
            this.message=data;
            for(let i =0; i<=this.message.length;i++){
              if(this.message[i]){
                 this.source = this.message[i].source;
              }
            }
            });
            this.http
            .get(
              encodeURI(
                this.hostUrl + "/api/issue/activatedProjects/" + this.projectId
              )
            )
            .subscribe(data => {
              this.project = data;
              for (let i = 0; i <= this.project.length; i++) {
                if(this.project[i]){
              this.projectName = this.project[i].project_name;
                }
              }
            });
  }

  onDone() {
    const url = '/cqm-ns';
    this.router.navigate([url]);
  }
  sortBy(field) {
    if (this.oldField == field) {
      this.isDesc = !this.isDesc;
      this.order = !this.order;
    } else {
      this.isDesc = false;
      this.order = false;
      this.oldField = field;
    }
    if (this.order) {
      field = "-" + field;
    }
    if (field === "review_date" || field === "-review_date") {
      this.sortreview_date = this.isDesc ? "fa fa-sort-desc" : "fa fa-sort-asc";
      this.sortDescription = "fa fa-sort";
      this.sortautoClassification = "fa fa-sort";
      this.sortRootCause = "fa fa-sort";
    } else if (field === "Description" || field === "-Description") {
      this.sortDescription = this.isDesc ? "fa fa-sort-desc" : "fa fa-sort-asc";
      this.sortautoClassification = "fa fa-sort";
      this.sortRootCause = "fa fa-sort";
      this.sortreview_date = "fa fa-sort"; 
    } else if (field === "autoClassification" || field === "-autoClassification") {
      this.sortRootCause = this.isDesc ? "fa fa-sort-desc" : "fa fa-sort-asc";
      this.sortDescription = "fa fa-sort";
      this.sortRootCause = "fa fa-sort";
      this.sortreview_date = "fa fa-sort"; 
    } else if (field === "rootcause" || field === "-rootcause") {
      this.sortRootCause = this.isDesc ? "fa fa-sort-desc" : "fa fa-sort-asc";
      this.sortDescription = "fa fa-sort";
      this.sortautoClassification = "fa fa-sort";
      this.sortreview_date = "fa fa-sort"; 
    } 

    this.approvedIssues = this.approvedIssues.sort(
      this.userService.dynamicSort(field)
    );
  }
  projectPopup() {
    

    const dialogConfig = new MatDialogConfig();

    // dialogConfig.panelClass = "login-modalbox";

    dialogConfig.backdropClass = 'popupBackdropClass';

    dialogConfig.maxHeight = window.innerHeight - 20 + 'px' ; 

    dialogConfig.panelClass = "ns-modalbox";
    dialogConfig.disableClose = false;
    this.matDialog.open(CqmnsProjectPopupComponent, dialogConfig);

}
}



// WEBPACK FOOTER //
// ./src/app/modules/cqm-ns/cqm-ns-actions/cqmns-approved-rca/cqmns-approved-rca.component.ts